{
  "version": 1,
  "asset_id": "9ace4ca8-d4d5-4c7a-9192-183ee89a0037",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/9ace4ca8-d4d5-4c7a-9192-183ee89a0037/destination-roofing-owner-sales-team-crystal-river-fl-640w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/9ace4ca8-d4d5-4c7a-9192-183ee89a0037/destination-roofing-owner-sales-team-crystal-river-fl-640w.webp",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-640w.webp",
  "size": 31862,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:45Z"
}
